import { create } from '@bufbuild/protobuf';

import { wsAppRequestManager } from '../WsAppApi';
import {
  GetWorkspaceRequest,
  GetWorkspaceRequestSchema,
  GetWorkspaceUsersRequest,
  GetWorkspaceUsersRequestSchema,
  SearchUsersInWorkspaceRequest,
  SearchUsersInWorkspaceRequestSchema,
} from '../types/workspace/workspace_requests_pb';
import {
  GetWorkspaceResponse,
  GetWorkspaceUsersResponse,
  SearchUsersInWorkspaceResponse,
} from '../types/workspace/workspace_responses_pb';
import { WsRequest } from './request.types';

export function getWorkspaceRequest(
  data: WsRequest<GetWorkspaceRequest> = {}
): Promise<GetWorkspaceResponse> {
  return wsAppRequestManager.request<GetWorkspaceResponse>({
    case: 'getWorkspace',
    value: create(GetWorkspaceRequestSchema, data),
  });
}

export function searchUsersInWorkspaceRequest(
  data: WsRequest<SearchUsersInWorkspaceRequest>
): Promise<SearchUsersInWorkspaceResponse> {
  return wsAppRequestManager.request<SearchUsersInWorkspaceResponse>({
    case: 'searchUsersInWorkspace',
    value: create(SearchUsersInWorkspaceRequestSchema, data),
  });
}

export function getUsersInWorkspaceRequest(
  data: WsRequest<GetWorkspaceUsersRequest>
): Promise<GetWorkspaceUsersResponse> {
  return wsAppRequestManager.request<GetWorkspaceUsersResponse>({
    case: 'getWorkspaceUsers',
    value: create(GetWorkspaceUsersRequestSchema, data),
  });
}
